
<div class="checkin">
  <div class="header">
    <div class="title">
      {{"PAGES.MANAGEMENT.BASKET_CAPACITY_DIALOG.TITLE" | translate}}
      <span (click)="closeDialog()" class="material-icons side-nav-bar-close">clear</span>
    </div>
  </div>
  <div class="body">


    <p class="text-value">
      {{('PAGES.MANAGEMENT.BASKET_CAPACITY_DIALOG.TEXT.0' | translate)}}
      <br>
      {{('PAGES.MANAGEMENT.BASKET_CAPACITY_DIALOG.TEXT.1' | translate)}}
    </p>

  </div>
  <div class="footer">
    <button (click)="closeDialog(true)">
      {{('PAGES.MANAGEMENT.BASKET_CAPACITY_DIALOG.CONFIRM' | translate) | uppercase }}
    </button>
  </div>
</div>
